import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Loader2 } from 'lucide-react';
import { TrackerLayout } from './TrackerLayout';
import { trackerGet, CARD, compact } from './trackerApi';

const Split = ({ reel, other }) => {
  const total = reel + other || 1;
  return (
    <div>
      <div className="flex h-2 rounded-full overflow-hidden bg-[#FFF1EB]">
        <div className="bg-[#FF451A]" style={{ width: `${(reel / total) * 100}%` }} />
        <div className="bg-[#FDBA8C]" style={{ width: `${(other / total) * 100}%` }} />
      </div>
      <div className="flex justify-between text-[11px] text-[#71717A] mt-1.5"><span>Reels {reel}</span><span>Static {other}</span></div>
    </div>
  );
};

const CompetitorCard = ({ c, i }) => (
  <Link to={`/brand/competitors/${c.instagram_handle}`} className={`${CARD} group p-6 block hover:border-[#FF451A]/40 hover:-translate-y-0.5 hover:shadow-[0_12px_32px_rgba(255,69,26,0.1)] transition-[transform,box-shadow,border-color] duration-300 animate-in fade-in slide-in-from-bottom-2`} style={{ animationDelay: `${i * 70}ms`, animationFillMode: 'both' }} data-testid={`competitor-card-${c.instagram_handle}`}>
    <div className="flex items-start justify-between mb-6">
      <div>
        <h3 className="text-xl font-bold tracking-tight">{c.name}</h3>
        <div className="text-xs text-[#71717A]">@{c.instagram_handle}</div>
      </div>
      <ArrowUpRight size={18} className="text-[#A1A1AA] group-hover:text-[#FF451A] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-[transform,color]" />
    </div>
    <div className="grid grid-cols-3 gap-3 mb-5">
      <div><div className="text-2xl font-bold" data-testid={`competitor-posts-${c.instagram_handle}`}>{c.post_count}</div><div className="text-[11px] text-[#71717A]">posts this month</div></div>
      <div><div className="text-2xl font-bold" data-testid={`competitor-reach-${c.instagram_handle}`}>{compact(c.total_reach)}</div><div className="text-[11px] text-[#71717A]">est. reach</div></div>
      <div><div className="text-2xl font-bold text-[#FF451A]">{c.top_tier || '—'}</div><div className="text-[11px] text-[#71717A]">top tier</div></div>
    </div>
    <Split reel={c.type_split.reel} other={c.type_split.static + c.type_split.story} />
  </Link>
);

const Grid = () => {
  const [d, setD] = useState(null);
  useEffect(() => { trackerGet('/competitors').then(setD); }, []);
  if (!d) return <Loader2 className="animate-spin text-[#FF451A]" size={18} />;
  if (!d.competitors.length) return <p className="text-sm text-[#6B6B6B]" data-testid="competitors-empty">No competitors tracked yet.</p>;
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="competitors-grid">{d.competitors.map((c, i) => <CompetitorCard key={c.instagram_handle} c={c} i={i} />)}</div>;
};

export default function CompetitorsOverview() {
  return (
    <TrackerLayout title="Competitors" subtitle="Last 30 days of creator activity for each brand you track. Click a card for the full breakdown.">
      {() => <Grid />}
    </TrackerLayout>
  );
}
